module.exports = __webpack_public_path__ + "static/media/twilio-logo-red.4604e214.png";